<dx-chart
  class="chart"
  palette="bright"
  [dataSource]="data">
  <dxo-title text="Tranche d'age du Parc Tracteurs" horizontalAlignment="center">
    <dxo-font [weight]="300" [size]="18"></dxo-font>
  </dxo-title>
  <!--<dxo-adaptive-layout [height]="300" [width]="400"></dxo-adaptive-layout>-->
  <dxo-legend
    orientation="horizontal"
    itemTextPosition="right"
    horizontalAlignment="center"
    verticalAlignment="bottom"
    [columnCount]="4"></dxo-legend>
  <dxo-export [enabled]="false"></dxo-export>
  <dxi-series valueField="0to5" name="0 à 5ans"></dxi-series>
  <dxi-series valueField="6to15" name="6 à 15ans"></dxi-series>
  <dxi-series valueField="sup15" name="Sup à 15ans"></dxi-series>
  <dxo-common-series-settings argumentField="domainName" type="bar">
    <dxo-label
      [visible]="true">
    </dxo-label>
  </dxo-common-series-settings>
</dx-chart>
